<template>
  <w-icon-wrapper
    :height='24'
    :width='22'
    icon-name='work-save-icon'
    view-box='0 0 22 24'
  >
    <g
      id='_11_Speichern_Icon'
      data-name='11 Speichern_Icon'
      transform='translate(-1 0.063)'
    >
      <path
        id='Pfad_55657'
        d='M18-.063H1v24H23V3.958ZM7,2H9V4.5a1,1,0,0,0,2,0V2h5V7H7ZM21,21.937H3v-20H5V9H18V2.5l3,2.413Z'
        data-name='Pfad 55657'
        fill='currentColor'
      />
      <path
        id='Pfad_55658'
        d='M12,12a4,4,0,1,0,4,4A4,4,0,0,0,12,12Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,18Z'
        data-name='Pfad 55658'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconSave' };
</script>
